import {createOrganization, deleteOrganization, updateOrganization} from "../api/organization";
import {ORGANIZATION_MODAL_CONTENT} from "../components/OrganizationModalContent";

const DEFAULT_USER = {name: "", group: []};

type UseOrganizationMutationsProps = {
  userToken: string;
  editingOrganization: any;
  currentOrganization: any;
  setDialogContent: (content: ORGANIZATION_MODAL_CONTENT | "") => void;
  setMessage: (message: string) => void;
  setMessageType: (type: "success" | "fail") => void;
  setEditingOrganization: (organization: any) => void;
  setCurrentOrganization: (organization: any) => void;
  setDeletingOrgId: (id: string) => void;
  fetchOrganizations: () => Promise<void>;
};

export const useOrganizationMutations = ({
  userToken,
  editingOrganization,
  currentOrganization,
  setDialogContent,
  setMessage,
  setMessageType,
  setEditingOrganization,
  setCurrentOrganization,
  setDeletingOrgId,
  fetchOrganizations,
}: UseOrganizationMutationsProps) => {
  const handleSaveOrganization = async () => {
    setDialogContent(ORGANIZATION_MODAL_CONTENT.LOADING);
    try {
      if (editingOrganization) {
        await updateOrganization({
          token: userToken,
          organization: {
            id: editingOrganization.id,
            ...currentOrganization
          }
        });
      } else {
        await createOrganization({token: userToken, organization: currentOrganization});
      }

      await fetchOrganizations();
      setEditingOrganization(null);
      setCurrentOrganization(DEFAULT_USER);
      setDialogContent(ORGANIZATION_MODAL_CONTENT.MESSAGE);
      setMessage(`已成功${editingOrganization ? "更新" : "新增"}`);
      setMessageType("success");
    } catch (error) {
      setDialogContent(ORGANIZATION_MODAL_CONTENT.MESSAGE);
      setMessage(error.message);
      setMessageType("fail");
    }
  };

  const handleDeleteOrganization = async (orgId: string) => {
    setDialogContent(ORGANIZATION_MODAL_CONTENT.LOADING);
    try {
      const response = await deleteOrganization({token: userToken, id: orgId});

      if (response.success) {
        await fetchOrganizations();
        setDialogContent(ORGANIZATION_MODAL_CONTENT.MESSAGE);
        setMessage("已成功刪除");
        setMessageType("success");
        setDeletingOrgId("");
      } else if (response.message === "User dependencies") {
        setDialogContent(ORGANIZATION_MODAL_CONTENT.MESSAGE);
        setMessageType("fail");
        setMessage("因為有帳號綁定在此組別，所以無法刪除");
      } else {
        setDialogContent(ORGANIZATION_MODAL_CONTENT.MESSAGE);
        setMessageType("fail");
        setMessage("刪除失敗，請稍候再試一次");
      }
    } catch (error) {
      setDialogContent(ORGANIZATION_MODAL_CONTENT.MESSAGE);
      setMessageType("fail");
      setMessage(error.message);
    }
  };

  return {
    handleSaveOrganization,
    handleDeleteOrganization,
  };
};
